import React from 'react'

export default function Search({ fill }) {


    return (
        <svg className='searchbar__icon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.9635 12.0242C8.31325 14.1468 4.43381 13.9798 1.97703 11.523C-0.65901 8.88693 -0.65901 4.61307 1.97703 1.97703C4.61307 -0.65901 8.88693 -0.659009 11.523 1.97703C13.9798 4.43381 14.1468 8.31324 12.0242 10.9635L17.1798 16.1191C17.4727 16.412 17.4727 16.8869 17.1798 17.1798C16.8869 17.4727 16.412 17.4727 16.1191 17.1798L10.9635 12.0242ZM3.03769 10.4623C0.987437 8.41206 0.987437 5.08794 3.03769 3.03769C5.08794 0.987437 8.41206 0.987437 10.4623 3.03769C12.5111 5.08644 12.5126 8.40718 10.4668 10.4578C10.4653 10.4593 10.4638 10.4608 10.4623 10.4623C10.4608 10.4638 10.4593 10.4653 10.4578 10.4668C8.40719 12.5126 5.08644 12.5111 3.03769 10.4623Z" fill={fill} />
        </svg>

    )
}
